import React from 'react'

const Sale = () => {
  return (
    <div className='clothmain'>
    <p style={{textAlign:"center"}}>sale</p>

    <div className='cloth1'>
      <div id='cloth1child'>
        <img src="https://images.ctfassets.net/5de70he6op10/49ZN2bC1GSrPz57veyGnGu/60a4a4ff587ad34d08ff2b744baf2976/Casual_Text.jpg?w=630&q=80&fm=webp" alt="" />
      </div>
      <div id='cloth1child'>
        <img src="https://images.ctfassets.net/5de70he6op10/1DlsysSG4ETmC3G7DvKsZP/3317c0b53d59a8c33aac87d7e5ca7bf2/Party_Text.jpg?w=630&q=80&fm=webp" alt="" />
      </div>
      <div id='cloth1child'>
        <img src="https://images.ctfassets.net/5de70he6op10/5H08nws8ZSjUGkae6rDamQ/fc2ee28cd74d54788e9bca6b03bea20f/White_Text.jpg?w=630&q=80&fm=webp" alt="" />
      </div>
      <div id='cloth1child'>
        <img src="https://images.ctfassets.net/5de70he6op10/7sBhabDqL1c2zVvyXNFIf/b5fd57c71d3c45abe6582231b3d4d8c8/Wedding_Text.jpg?w=630&q=80&fm=webp" alt="" />
      </div>
      <div id='cloth1child'>
        <img src="https://images.ctfassets.net/5de70he6op10/6j7vctx8pVdBvsZ5YtxgjT/941f07ccaf581ac974413389a75e0bdc/Black_Text.jpg?w=630&q=80&fm=webp" alt="" />
      </div>
      <div id='cloth1child'>
        <img src="https://images.ctfassets.net/5de70he6op10/6aGiwPaIMLxjOfGxHhedpB/8410af29c1e4442f800dfb024dc6252b/Formal_Text.jpg?w=630&q=80&fm=webp" alt="" />
      </div>

    </div>


</div>
  )
}

export default Sale
